// Nav Constants ---------------------------------------------------------------------------------------------------------------------------

export const NAV_HEADER_THEME_STORAGE_NAME = 'portal-admin';

export const NAV_HEADER_NAME = {
  Prefix: 'portal',
  Suffix: 'admin',
};
